import React, { useState } from "react";
import Countdown from "react-countdown";
import { useQueryClient } from "react-query";
import { Timer_INIT } from "../../config/cacheKey";

interface rendererPropsInterface {
    hours: any,
    minutes: any,
    seconds: any,
    completed: any
}

// Renderer callback with condition

interface CountdownCmpPropsInterface {
    onCompletedClick: any,
    countDownValue: number,
    btnName: string
}

export const CountdownCmp = ({ onCompletedClick, countDownValue, btnName }: CountdownCmpPropsInterface) => {
    const queryClient = useQueryClient();
    let timerInitFlag = queryClient.getQueryData<boolean>(Timer_INIT);
    const [timer, setTimer] = React.useState<number>(Date.now() + countDownValue)
    const [timerInit, settImerInit] = React.useState<boolean>(timerInitFlag!)
    function handleOnChildClick() {
        setTimer(Date.now() + countDownValue);
        settImerInit(true)
        onCompletedClick();
    }

    const renderer = ({ hours, minutes, seconds, completed }: rendererPropsInterface) => {
        if (completed || timerInit === false) {
            // Render a completed state
            return <p className="cursorPointer" onClick={handleOnChildClick}>  {btnName} </p>;
        } else {
            // Render a countdown
            return <span>{minutes}:{seconds}</span>;
        }
    };

    return (<Countdown
        overtime={true}
        date={timer}
        renderer={renderer} />)
}